<template>
  <div id="printReport">
    <div class="row">
      <div class="col-sm-2">
        <img src="@/assets/template/images/logo.png" alt="Consyst" style="height: 60px" />
      </div>
      <div class="col-sm-10">
        <h3 class="text-center">Relatório de Comissão por Perfil</h3>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-sm-12">
        <div class="panel panel-defaul">
          <div class="panel-body">
            <div class="row">
              <div class="col-md-3">
                <label>Administradora</label>
                <br />
                {{ (form.administrator_id == null || form.administrator_id == '') ? 'Todas' : administrator }}
              </div>
              <div class="col-md-3">
                <label>Equipe</label>
                <br />
                {{ form.team_id == null ? 'Todas' : team }}
              </div>
              <div class="col-md-3">
                <label>Filtrar por</label>
                <br />
                {{ date }}
              </div>
              <div class="col-md-3">
                <label>Intervalo</label>
                <br />
                {{ init_at | moment('DD/MM/YYYY') }} à {{ end_at | moment('DD/MM/YYYY') }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br />
    <div class="row" v-show="report.length > 0" v-for="iterator in report" :key="iterator.id">
      <div class="col-md-12">
        <div class="panel panel-danger">
          <div class="panel-body">
            <b>Administratora: {{ iterator.name }}</b>
            <table-report
              v-if="iterator.proposals.salesmans"
              title-name="Vendedores"
              :items="iterator.proposals.salesmans"
            ></table-report>
            <table-report
              v-if="iterator.proposals.supervisors"
              title-name="Supervisores"
              :items="iterator.proposals.supervisors"
            ></table-report>
            <table-report
              v-if="iterator.proposals.managers"
              title-name="Gerentes"
              :items="iterator.proposals.managers"
            ></table-report>
            <table-report
              v-if="iterator.proposals.after_sales"
              title-name="Pós Venda"
              :items="iterator.proposals.after_sales"
            ></table-report>
          </div>
        </div>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-sm-12">
        <div class="panel panel-danger">
          <div class="panel-body">
            <h3 class="text-center">Resumo geral</h3>
              <table class="table" id="tabela">
                <thead class="thead-dark">
                  <tr>
                    <th class="text-center" rowspan="2">Nome</th>
                    <th class="text-center" rowspan="2">Vendas</th>
                    <th class="text-center" rowspan="2">Ticket Médio</th>
                    <th class="text-center" colspan="2" v-if="hasExtraReward()">Premiação Extra</th>
                    <th class="text-center" rowspan="2" v-if="hasPastChargeback()">Estorno Retroativo</th>
                    <th class="text-center" colspan="3">Totais</th>
                  </tr>
                  <tr>
                    <th class="text-center" v-if="hasExtraReward()">Descrição</th>
                    <th class="text-center" v-if="hasExtraReward()">Valor</th>
                    <th class="text-center">Comissão</th>
                    <th class="text-center">Prêmio por Volume</th>
                    <th class="text-center">Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="total in totals" :key="total.id">
                    <td>{{ total.name }}</td>
                    <td class="text-center">R${{ total.sales | price }}</td>
                    <td class="text-center">R${{ total.sales / total.quotes | price }}</td>
                    <td class="text-center" v-if="hasExtraReward() && total.extraRewardAmount > 0">{{ total.extraRewardName }}</td>
                    <td class="text-center" v-if="hasExtraReward() && total.extraRewardAmount == 0">--</td>
                    <td class="text-center" v-if="hasExtraReward() && total.extraRewardAmount > 0">R${{ total.extraRewardAmount | price }}</td>
                    <td class="text-center" v-if="hasExtraReward() && total.extraRewardAmount == 0">--</td>
                    <td class="text-center" v-if="hasPastChargeback() && total.pastChargebackAmount > 0">R${{ total.pastChargebackAmount | price }}</td>
                    <td class="text-center" v-if="hasPastChargeback() && total.pastChargebackAmount == 0">--</td>
                    <td class="text-center">R${{ total.commission | price }}</td>
                    <td class="text-center">R${{ total.byVolume | price }}</td>
                    <td class="text-center">R${{ total.commission + total.byVolume + total.extraRewardAmount - total.pastChargebackAmount | price }}</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td>Total</td>
                    <td class="text-center">R${{ totals.reduce((sum, total) => sum + total.sales, 0) | price }}</td>
                    <td class="text-center">R${{ totals.reduce((sum, total) => sum + total.sales, 0) / totals.reduce((sum, total) => sum + total.quotes, 0) | price }}</td>
                    <td class="text-center" v-if="hasExtraReward()">--</td>
                    <td class="text-center" v-if="hasExtraReward()">R${{ totals.reduce((sum, total) => sum + total.extraRewardAmount, 0) | price }}</td>
                    <td class="text-center" v-if="hasPastChargeback()">R${{ totals.reduce((sum, total) => sum + total.pastChargebackAmount, 0) | price }}</td>
                    <td class="text-center">R${{ totals.reduce((sum, total) => sum + total.commission, 0) | price }}</td>
                    <td class="text-center">R${{ totals.reduce((sum, total) => sum + total.byVolume, 0) | price }}</td>
                    <td class="text-center">R${{ totals.reduce((sum, total) => sum + total.commission + total.byVolume + total.extraRewardAmount - total.pastChargebackAmount, 0) | price }}</td>
                  </tr>
                </tfoot>
              </table>
          </div>
        </div>
      </div>
    </div>
    <div class="row dont-print">
      <div class="col-md-12 text-center">
        <button type="button" @click="close()" class="btn btn-fill btn-danger">Voltar</button>
        <button type="button" @click="print()" class="btn btn-fill btn-info">Imprimir</button>
        <button type="button" @click="pdf()" class="btn btn-fill btn-info">PDF</button>
        <!--button-- type="button" @click="excel()" class="btn btn-fill btn-success">Excel</!--button-->
      </div>
    </div>
  </div>
</template>
<script>
import TableReport from "@/components/elements/TableReportCommissionProfile";
import ExtraRewards from '@/services/modules/extra_rewards.service';
import Vue from 'vue';

export default {
  components: {
    "table-report": TableReport
  },
  computed: {
    administrators: {
      get() {
        return this.$store.state.administrators.itens;
      }
    },
    dates: {
      get() {
        var dates = [
          { id: "sale_at", name: "Data de Venda" },
          { id: "deployment_at", name: "Data Alocação" },
          { id: "pay_at", name: "Data de Pagamento" },
          { id: "pay_at-sale_at", name: "Data de Pagamento (volume por data da venda)" },
          { id: "due_at", name: "Data de Vencimento (apenas parcelas pagas)" },
          { id: "due_at-all", name: "Data de Vencimento (parcelas pagas e não pagas)" }
        ];

        return dates;
      }
    },
    report: {
      get() {
        return this.$store.state.reports.item;
      }
    },
    teams: {
      get() {
        return this.$store.state.teams.itens;
      }
    },
  },
  data() {
    return {
      administrator: null,
      date: null,
      end_at: null,
      form: {},
      init_at: null,
      team: null,
      extra_rewards: null,
      totals: [],
    };
  },
  methods: {
    close() {
      window.opener.focus();
      window.close();
    },
    async getData() {
      var self = this;

      self.$root.$emit("onLoading");
      const response = self.$store.dispatch(
        "reports/commissionByProfiles",
        self.form
      );

      response.then(function(_dataReports) {
        self.$root.$emit("onLoading");
        self.calculateTotals(_dataReports);
      });

      response.catch(function() {
        self.$root.$emit("onLoading");
      });
    },
    async getDataAdministrators() {
      var self = this;

      self.$root.$emit("onLoading");

      const response = self.$store.dispatch("administrators/all");

      response.then(function(_administrators) {
        var administrator = _administrators.find(
          administrator => administrator.id === self.form.administrator_id
        );
        if (administrator !== undefined) {
          self.administrator = administrator.name;
        }
        self.$root.$emit("onLoading");
        self.getDataTeams();
      });

      response.catch(function() {
        self.$root.$emit("onLoading");
        self.getDataTeams();
      });
    },

    async getDataTeams() {
      var self = this;

      self.$root.$emit("onLoading");

      const response = self.$store.dispatch("teams/all");

      response.then(function(_teams) {
        var team = _teams.find(team => team.id === self.form.team_id);
        if (team !== undefined) {
          self.team = team.name;
        }
        self.$root.$emit("onLoading");
        self.getExtraRewards();
      });

      response.catch(function() {
        self.$root.$emit("onLoading");
        self.getExtraRewards();
      });
    },
    async getExtraRewards() {
      const self = this;
      self.extra_rewards = await ExtraRewards.query({
          date_start: Vue.moment(self.init_at).format('YYYY-MM-DD'),
          date_end: Vue.moment(self.end_at).format('YYYY-MM-DD'),
      });
      self.getData();
    },
    calculateTotals(reportData) {
      const self = this;
      for (let i=0; i<reportData.length; i++) {
        for (let profile in reportData[i].proposals) {
          for (let j=0; j<reportData[i].proposals[profile].length; j++) {
            let salesmanData = reportData[i].proposals[profile][j];
            let salesmanTotals = self.totals.find(totals => totals.name == salesmanData.name);
            if (salesmanTotals === undefined) {
              salesmanTotals = {
                name: salesmanData.name,
                id: salesmanData.salesman_id,
                sales: 0,
                quotes: 0,
                commission: 0,
                byVolume: 0,
                extraRewardAmount: 0,
                extraRewardName: '',
                pastChargebackAmount: 0,
              };
              self.totals.push(salesmanTotals);
            }
            salesmanTotals.sales += salesmanData.sales;
            salesmanTotals.quotes += salesmanData.quotes;
            salesmanTotals.byVolume += salesmanData.commissions.byVolume;
            for (let quote in salesmanData.commissions.quotes) {
              salesmanTotals.commission += salesmanData.commissions.quotes[quote];
            }
          }
        }
      }
      self.totals.sort((a, b) => {
        if (a.name == b.name) {
          return 0;
        }
        return a.name > b.name ? 1 : -1;
      });
      for (let i=0; i<self.totals.length; i++) {
        let totals = self.totals[i];
        let extraReward = self.extra_rewards.find(extraReward => extraReward.salesman_id == totals.id);
        if (extraReward === undefined) {
          continue;
        }
        totals.extraRewardAmount = extraReward.reward_amount * 1;
        totals.pastChargebackAmount = extraReward.chargeback_amount * 1;
        totals.extraRewardName = extraReward.reward_name;
      }
    },
    hasExtraReward() {
      return this.totals.reduce((totalReward, totals) => totalReward + totals.extraRewardAmount, 0) > 0;
    },
    hasPastChargeback() {
      return this.totals.reduce((totalChargeback, totals) => totalChargeback + totals.pastChargebackAmount, 0) > 0;
    },
    print() {
      window.print();
    },
    excel() {
      let nome = "RELATÓRIO DE PRODUÇÃO MENSAL";
      let htmlPlanilha =
        '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>' +
        nome +
        '</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><title>' +
        nome +
        '</title></head><body><table>' +
        document.querySelector("#tabelas").innerHTML +
        '</table>';
      let htmlBase64 = btoa(htmlPlanilha);
      let link = "data:application/vnd.ms-excel;base64," + htmlBase64;
      let hyperlink = document.createElement("a");
      hyperlink.download = "Relatório de Produção Mensal";
      hyperlink.href = link;
      hyperlink.style.display = "none";
      document.body.appendChild(hyperlink);
      hyperlink.click();
      document.body.removeChild(hyperlink);
    },
    async pdf() {
      var self = this;

      self.$root.$emit("onLoading");

      const response = self.$store.dispatch(
        "reports/commissionByProfilesDownloadInPdf",
        self.form
      )

      response.then(function(_downloadPdf) {
          let filename = 'commissions-by-profile.pdf'
          let blob = new Blob([_downloadPdf], {type: 'application/pdf'});

          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = filename 
          link.click();

          self.$root.$emit("onLoading")
      });

      response.catch(function() {
        self.$root.$emit("onLoading");
      });
    },
  },
  mounted() {
    var self = this;

    self.form = JSON.parse(self.$route.query.form);

    self.getDataAdministrators();

    self.date = self.dates.find(date => date.id === self.form.date_by).name;

    self.init_at = self.form.date_at[0];

    self.end_at = self.form.date_at[1];
  }
};
</script>
<style type="scss">
@media print {
  .page{
    margin: 5%;
  }
  .dont-print {
    display: none;
  }
  .table{
    width: 80%;
  }
  .table .thead-dark th {
    color: #aaaaaa;
  }
  .panel-danger {
    border-color: #ebccd1;
    width: 93%;
    margin-left: 4%;
}
}
</style>